import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { authLogout } from '@actions/auth-actions';
import { Box } from '@material-ui/core';
import { Progress } from '@mui';

import UnstyledHeading from '@components/shared/unstyled-heading';

import './layouts/not-authenticated/not-authenticated.scss';
import { replace } from 'connected-react-router';
import { AUTH_LOGIN_ROUTE } from '@constants/auth';

const Logout = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(authLogout());
    // Go to login page without a destination, this resets the app to the default page
    dispatch(replace(AUTH_LOGIN_ROUTE));
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div styleName="not-authenticated-container">
      <Box display="flex" justifyContent="center" alignItems="center">
        <Box display="flex" flexDirection="column" alignItems="center">
          <UnstyledHeading rank={2} variant="h6">Signing out...</UnstyledHeading>
          <Box m={12}>
            <Progress size={70} thickness={4} />
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default Logout;
